// extracted by mini-css-extract-plugin
module.exports = {"graphContainer":"ProjectionGraph-module__graphContainer--7CqaN","xaxisTicks":"ProjectionGraph-module__xaxisTicks--V93yZ"};